module.exports = __webpack_public_path__ + "img/noimage.9cfb42e6.png";